export class Approver {
    _id: String;
    name: String;
    optional: boolean;
    approved: boolean;

    loadFromServer(r: any) {
        this._id = r._id;
        this.name = r.name;
        this.optional = r.optional;
        this.approved = r.approved;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Approver.model.ts